function isHTMLInputElement(element: HTMLElement | Element | EventTarget): element is HTMLInputElement {
  return element instanceof HTMLInputElement
}

export default isHTMLInputElement
